import React from 'react';
import { useState } from 'react';
import './ColorSettings.css';
export default function ColorSettings(props) {
    const [isActive, setActive] = useState("false");
    const [ismode, setMode] = useState('false');
    const clicked = () => {
        setActive(!isActive);
    }
    const Css={
        "--color":`${props.isValue ? props.mode : `rgba(255, 255, 255, 0.2);`}`
    }
    return (
        <>
            <div className="colorCan">
                <div className={`${isActive ? null : 'showColors'} colors`}>
                    <div className={
                        `${isActive ? null : 'showColor'
                        } 
                        redColor Color`
                    }
                        onClick={() => { props.toggleMode(`${ismode ? 'red' : 'red'}`, `${ismode ? false : true}`); setMode(!ismode ? true : false);setMode(false) }}
                    >
                    </div>
                    <div className={`${isActive ? null : 'showColor'} megenta Color`}

                        onClick={() => { props.toggleMode(`${ismode ? 'rgb(240, 42, 240)' : 'rgb(240, 42, 240)'}`, `${ismode ? false : true}`); setMode(!ismode ? true : false);setMode(false) }} />
                    <div className={`${isActive ? null : 'showColor'} green Color`}
                        onClick={() => { props.toggleMode(`${ismode ? 'green' : 'green'}`, `${ismode ? false : true}`); setMode(!ismode ? true : false);setMode(false) }} />
                    <div className={`${isActive ? null : 'showColor'} yellow Color`}
                        onClick={() => { props.toggleMode(`${ismode ? 'yellow' : 'yellow'}`, `${ismode ? false : true}`); ismode ? setMode(false) : setMode(true);setMode(false)}} />
                    <div className={`${isActive ? null : 'showColor'} white Color`}
                        onClick={() => { props.toggleMode(`${ismode ? 'cyan' : 'cyan'}`, `${ismode ? false : true}`); ismode?setMode(false):setMode(true);setMode(false)}} />
                    <div className={`${isActive ? null : 'showColor'} grey Color`}
                        onClick={() => { props.toggleMode(`${ismode ? 'rgb(69, 255, 48)' : 'rgb(69, 255, 48)'}`, `${ismode ? false : true}`); ismode?setMode(false):setMode(true);setMode(false)}} />
                    <div className={`${isActive ? null : 'showColor'} blue Color`}
                        onClick={() => { props.toggleMode(`${ismode ? 'Blue' : 'Blue'}`, `${ismode ? false : true}`); ismode?setMode(false):setMode(true);setMode(false)}} />
                </div>
                <i
                    className={
                        `${isActive ? null : 'rolling'} fa-solid fa-gear settings`
                    }
                    onClick={clicked} style={Css}>
                </i>
            </div>
        </>
    )
}
